import uniqid from "uniqid"

export default [
  {
    icon: "icon-home",
    path: "/estadisticas",
    text: "menus.leftmenu.start",
    key: uniqid()
  },
  {
    icon: "icon-folder-closed",
    iconOpen: "icon-folder",
    text: "menus.leftmenu.inbox.title",
    key: uniqid(),
    subMenu: [
      {
        icon: "icon-chevron-sign-to-right",
        path: "/emitidas/emitidas-como-pagador/pendientes",
        text: "menus.leftmenu.inbox.pending",
        key: uniqid()
      },
      {
        icon: "icon-chevron-sign-to-right",
        path: "/emitidas/emitidas-como-pagador/tratadas",
        text: "menus.leftmenu.inbox.treated",
        key: uniqid()
      }
    ]
  },
  {
    icon: "icon-folder-closed",
    iconOpen: "icon-folder",
    text: "menus.leftmenu.outbox.title",
    key: uniqid(),
    subMenu: [
      {
        icon: "icon-chevron-sign-to-right",
        path: "/alta/facturas-sin-emitir",
        text: "menus.leftmenu.outbox.pending",
        key: uniqid()
      },
      {
        icon: "icon-chevron-sign-to-right",
        path: "/emitidas/emitidas-como-proveedor/enviadas",
        text: "menus.leftmenu.outbox.sent",
        key: uniqid(),
        subMenu: [
          {
            icon: "icon-chevron-sign-to-right",
            path: "/emitidas/emitidas-como-proveedor/aceptadas",
            text: "menus.leftmenu.outbox.accepted",
            key: uniqid()
          },
          {
            icon: "icon-chevron-sign-to-right",
            path: "/emitidas/emitidas-como-proveedor/rechazadas",
            text: "menus.leftmenu.outbox.rejected",
            key: uniqid()
          }
        ]
      }
    ]
  },
  /* {
    icon: "icon-folder-closed",
    iconOpen: "icon-folder",
    text: "menus.leftmenu.sii.title",
    key: uniqid(),
    subMenu: [
      {
        icon: "icon-chevron-sign-to-right",
        path: "/sii/lrfe",
        text: "menus.leftmenu.sii.lrfe",
        key: uniqid()
      }
    ]
  }, */
  {
    icon: "icon-search",
    path: "/buscador",
    text: "menus.leftmenu.search",
    key: uniqid()
  },
  {
    icon: "icon-storage",
    path: "/buscador/antiguas",
    text: "menus.leftmenu.stored",
    key: uniqid()
  }
]
